export default "__VITE_ASSET___94SjOFZ__"